import React, { useState, useEffect, useRef } from 'react'
import BasicInfoContainer from './BasicInfoContainer'
import OperationsContainer from '../operation/OperationsContainer'
import BackgroundInfoContainer from './BackgroundInfoContainer'
import CommitmentReportContainer from './CommitmentReportContainer'
import AgendaContainer from '../agenda/AgendaContainer'
import LanguageSelection from './LanguageSelection'
import TitleDisplay from './TitleDisplay'

import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'

import {
    showSuccessNotification,
    startedSavingNotification,
    showSaveDraftNotification,
    showDeletedNotification,
    showErrorNotification,
    showErrorTextNotification, showSuccessTextNotification
} from '../helpers/Notifications'

import commitmentSlice from '../../../state/slices/commitmentSlice'
import validatorSlice from '../../../state/slices/validatorSlice'
import moment from "moment";
import {isMaterialOrGD} from "../helpers/Categories";
import translate from "../../reusable/translate";

const CreationForm = ({
    fetchedCommitment,
    isJoining,
    commitmentToJoin,
    commitmentCategoryId,
    commitmentSubcategoryId,
    organizationName,
    createdByUserId,
    mainGoal,
    greenDealOperations,
    hunderToDoMeters
}) => {
    const [saving, setSaving] = useState(false)
    const [loading, setLoading] = useState(true)

    const dispatch = useDispatch()
    const { commitment } = useSelector((state) => state)
    const { validators } = useSelector((state) => state)


    const {
        changeTitleValidator,
        changeDateValidator,
        changeCityValidator,
        changeShortDescValidator,
        changeBackgroundDescValidator,
        changeOperationsValidator,
        changeMeterValidator,
        changeLevelValidator,
        changeOwnMeterValidator,
    } = bindActionCreators(validatorSlice.actions, dispatch) //validators

    const {
        changeCategoryId,
        changeSubcategoryId,
        changeCommitmentId,
        changeCreatedByUserId,
        changeCommitmentType,
        changeOrganizationName,
        changeStatus,
        setCategoryIds,
        setCommitment,
        resetCommitment,
    } = bindActionCreators(commitmentSlice.actions, dispatch) //commitment fields

    useEffect(() => {
        if(isJoining && commitmentToJoin){
            fetchedCommitment = {...fetchedCommitment, commitment: commitmentToJoin};
            fetchedCommitment.commitment = {
                ...fetchedCommitment.commitment,
                id: '',
                commitmentData:{
                commitmentType: commitmentToJoin.commitmentType,
                categoryIds: commitmentToJoin.categoryIds}
            };
        }
        changeCategoryId(commitmentCategoryId ||
            (fetchedCommitment.commitment && fetchedCommitment.commitment.commitmentCategoryId
                ? fetchedCommitment.commitment.commitmentCategoryId
                : ''))
        changeSubcategoryId(commitmentSubcategoryId ||
            (fetchedCommitment.commitment && fetchedCommitment.commitment.commitmentSubcategoryId
                ? fetchedCommitment.commitment.commitmentSubcategoryId
                : ''))
        changeCommitmentId((fetchedCommitment.commitment && fetchedCommitment.commitment.id) || '')
        changeCreatedByUserId(createdByUserId || fetchedCommitment.commitment.createdByUserId)
        changeCommitmentType(fetchedCommitment.commitmentData.commitmentType || '')
        changeOrganizationName(organizationName || fetchedCommitment.commitment.organizationName)
        changeStatus((fetchedCommitment.commitment && fetchedCommitment.commitment.status) || '')
        setCategoryIds(fetchedCommitment.commitment ? [fetchedCommitment.commitment.categoryIds] : [])

        setLoading(false)
    }, [])


    // useRefs for scrolling when invalid form
    const titleRef = useRef()
    const shortDescriptionRef = useRef()
    const backgroundDescriptionRef = useRef()
    const operationsRef = useRef()
    const meterRef = useRef()
    const dateRef = useRef()

    useEffect(() => {
        setCommitment({
            ...fetchedCommitment.commitment,
            categoryIds: commitment.categoryIds.concat(
                fetchedCommitment.commitmentData.categoryIds
            ),
            reportingInterval: "CUSTOM"
        })

        return () => { // called when component unmounts
            resetCommitment()
        }
    }, [])

    useEffect(() => {
        if(!commitment.createdByUserId && createdByUserId){
            changeCreatedByUserId(createdByUserId)
        }
    }, [commitment.createdByUserId])

    const saveDraft = () => {
        saveCommitment({
            ...commitment,
            categoryIds: commitment.categoryIds.concat(
                commitment.commitmentCategoryId,
                commitment.commitmentSubcategoryId
            ).filter(Number),
            organizationName: commitment.organizationName === "Yksityishenkilönä" ? "" : commitment.organizationName,
            status: 'draft'
        }, 'draft')
    }

    const redirectToCommitments = () => {
        window.setTimeout(() => {
            window.location.href = '/profiili#/sitoumukset'
        }, 1500)
    }

    const saveApproved = () => {
        // form validation and saving
        let hasStartAndTargetLevel = true
        let hasOwnMeter = true
        let hasMeters = true
        if (!commitment.endDate) {
            changeDateValidator(false)
            dateRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return
        } else if (!commitment.title_fi_FI) {
            changeTitleValidator(false)
            titleRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
            return
        } else if (!commitment.address) {
            changeCityValidator(false)
            titleRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return
        } else if (!commitment.shortDescription_fi_FI) {
            changeShortDescValidator(false)
            shortDescriptionRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return
        } else if (!commitment.backgroundInformation_fi_FI) {
            changeBackgroundDescValidator(false)
            backgroundDescriptionRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return
        } else if (!commitment.operations.length) {
            changeOperationsValidator(false)
            operationsRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return
        } else if (!validators.mainGoal) {
            showErrorTextNotification("Valitse sitoumukselle vähintään yksi muutosalue")
            return
        }

        commitment.operations.forEach((o) => {
            o.meters.forEach((m) => {
                hasOwnMeter = m.meterType_fi_FI !== ''
            })
        })
        commitment.operations.forEach((o) => {
            o.meters.forEach((m) => {
                hasStartAndTargetLevel =
                    (m.startingLevel !== '' && m.targetLevel !== '') ||
                    !(m.meterValueType === 'NUMBER')
            })
        })
        commitment.operations.forEach((o) => {
            hasMeters = o.meters.length !== 0
        })
        if (!hasMeters) {
            changeMeterValidator(false)
            meterRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
            return
        }
        if (!hasStartAndTargetLevel) {
            changeLevelValidator(false)
            meterRef.current.scrollIntoView({
                behavior: 'smooth' 
            })
            return
        }
        if (!hasOwnMeter) {
            changeOwnMeterValidator(false)
            meterRef.current.scrollIntoView({
                behavior: 'smooth' 
            })
            return
        }

        saveCommitment({
            ...commitment,
            categoryIds: commitment.categoryIds.concat(
                commitment.commitmentCategoryId,
                commitment.commitmentSubcategoryId
            ).filter(Number),
            organizationName: commitment.organizationName === "Yksityishenkilönä" ? "" : commitment.organizationName,
            status:  commitment.status,
            startDate: commitment.startDate || moment(new Date()).toJSON(),
            operations: commitment.operations.map((mappedOperation) => ({ ...mappedOperation, published: true })),
        }, 'approved').then(() => redirectToCommitments())
    }

    const saveCommitment = async (commitmentToSave, status) => {
        if (!saving) {
            setSaving(true)
            startedSavingNotification()
            await fetch('/o/commitment2050-service/commitmentapi/commitments', {
                method: 'POST',
                body: JSON.stringify(commitmentToSave),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
                credentials: 'include'
            }).then((res) => {
                if (res.status < 300) {
                    if (status === 'draft') {
                        showSaveDraftNotification()
                    } else if (status === 'approved') {
                        showSuccessNotification()
                    }
                } else if (res.status > 300) {
                    showErrorNotification()
                }

                res.json().then((res) => {
                    changeCommitmentId(res.id)

                    if(isJoining){
                        const formData = new FormData();
                        formData.append("parentCommitmentId", commitmentToJoin.id);
                        formData.append("childCommitmentId", res.id);
                        fetch('/o/commitment2050-service/commitmentapi/commitments/jointoparent', {
                            method: 'POST',
                            body: formData,
                            headers: {
                                Accept: 'application/json, text/plain, */*',
                                'Content-Type': 'multipart/form-data',
                                'Cache-Control': 'no-cache'
                            },
                            credentials: 'include'
                        }).then((res2) => {
                            if (res.status < 300) {
                                showSuccessTextNotification(translate({textKey: "sit.notification.success.joining"}))
                            } else if (res.status > 300) {
                                showErrorTextNotification(translate({textKey: "sit.notification.error.joining"}))
                            }
                        })
                    }

                    setSaving(false)
                    if(status === 'approved') {
                        fetch(
                            '/o/commitment2050-service/commitmentapi/sendemailnotify',
                            {
                                method: 'POST',
                                body: JSON.stringify(res),
                                headers: {
                                    Accept: 'application/json, text/plain, */*',
                                    'Content-Type': 'application/json',
                                    'Cache-Control': 'no-cache'
                                },
                                credentials: 'include'
                            }
                        ).then()
                    }
                })
            })

        }
    }

    const deleteDraft = async () => {
        try {
            await fetch(
                `/o/commitment2050-service/commitmentapi/commitments/drafts/${commitment.id}`,
                {
                    method: 'DELETE'
                }
            ).then((res) => {
                if (res.status === 200) {
                    //STATUS OK
                    showDeletedNotification()
                    redirectToCommitments()
                }
            })
        } catch (err) {
            console.error('ERR', err)
        }
    }

    const printRef = useRef()


    if (loading) return null
    return (
        <div ref={printRef}>

            {(commitment.isGreenDeal || commitment.commitmentType === 'GREEN_DEAL') && (
                <TitleDisplay
                    saveDraft={saveDraft}
                    text={`Green deal -sitoumuksen ${commitment.isGreenDeal ? 'muokkaaminen' : 'luominen'}`}
                    categoryId={commitment.commitmentCategoryId}
                    status={commitment.status}
                />
            )}

            {commitment.commitmentType === 'MATERIAL' && (
                <TitleDisplay
                    saveDraft={saveDraft}
                    text={'Materiaalitehokkuuden sitoumuksen luominen'}
                    categoryId={commitment.commitmentCategoryId}
                    status={commitment.status}
                />
            )}

            <LanguageSelection/>

            <BasicInfoContainer // Contains info about creator and commitment
                shortDescriptionRef={shortDescriptionRef}
                dateRef={dateRef}
                titleRef={titleRef}
                fetchedCommitment={fetchedCommitment}
            />

            <div className="page-break-after"/>

            <OperationsContainer // Contains operations & meters
                greenDealOperations={greenDealOperations}
                generalActions={fetchedCommitment.generalActions}
                meterRef={meterRef}
                operationsRef={operationsRef}
                hundredToDoMeters={isJoining ? hunderToDoMeters : undefined}
            />

            <div className="page-break-after"/>

            <BackgroundInfoContainer // Contains mainly text boxes
                backgroundDescriptionRef={backgroundDescriptionRef}
            />

            <div className="page-break-after"/>

            <AgendaContainer // Contains goals and agenda goals
                fetchedCommitment={fetchedCommitment}
                mainGoal={isMaterialOrGD(commitment.commitmentType) ? mainGoal : null}
            />

            <CommitmentReportContainer // Contains checkboxes and save, delete etc buttons
                saveDraft={saveDraft}
                saveApproved={saveApproved}
                deleteDraft={deleteDraft}
                printRef={printRef}
            />
        </div>
    )
}

export default CreationForm



// WEBPACK FOOTER //
// ./src/components/materialCommitment/commitment/MaterialCommitmentCreationForm.jsx